<template>
  <v-container fluid class="no-indentation mb-12">
    <v-row class="partnership">
      <partnership-submenu :toggle_none="this.toggle_exclusive"/>
    </v-row>
    <v-row class="partnership">
      <v-col v-if="show1 || isAuth" cols="12" lg="12" md="12" sm="12" class="partnership__content">
        <content-text
            :title="$t('message.partnershipSubHead3')"
            :content="'<p>'+ gorHref + ' - ' + $t('message.partnershipText10') +
            span1 + $t('message.partnershipText11') + '</p>' +
            '<p>'+ $t('message.partnershipText12')+ '</p>' +
            '<p>'+ span2+' ' + $t('message.partnershipText14')+'</p>'"
            :id_title="330"
            :id_sub-title="331"
            :id_content="332"
            :hidden="!show1"
            title-class="contentHeading"
            sub-title-class="contentSubTitle"
            text-class="contentText"
        />
      </v-col>
    </v-row>
    <div class="partnership">
      <div class="partnership__images-container">
        <div v-for="id in imagesIds" class="partnership__image-and-text">
          <content-image
              class="partnership__image"
              :img-src="$t('message.partnershipSchemeSRC')"
              :is_link="true"
              :id_img-src="id"
              img-class="partnershipImg"
          />
          <content-text
              v-if="showObject[id] || isAuth"
              class="partnership__text"
              :title="$t('message.partnershipSubHead3')"
              :content="'<p>'+ gorHref + ' - ' + $t('message.partnershipText10') +
            span1 + $t('message.partnershipText11') + '</p>' +
            '<p>'+ $t('message.partnershipText12')+ '</p>' +
            '<p>'+ span2+' ' + $t('message.partnershipText14')+'</p>'"
              :id_title="id + 1"
              :id_sub-title="id + 2"
              :id_content="id + 3"
              :hidden="!showObject[id]"
              title-class="contentHeading"
              sub-title-class="contentSubTitle"
              text-class="contentText"
          />
        </div>
      </div>
    </div>
    <v-row class="partnership">
      <v-col v-if="show2 || isAuth" cols="12" lg="5" md="5" sm="11" class="partnership__content">
        <content-text
            :title="$t('message.partnershipSubHead3')"
            :content="'<p>'+ gorHref + ' - ' + $t('message.partnershipText10') +
            span1 + $t('message.partnershipText11') + '</p>' +
            '<p>'+ $t('message.partnershipText12')+ '</p>' +
            '<p>'+ span2+' ' + $t('message.partnershipText14')+'</p>'"
            :id_title="333"
            :id_sub-title="334"
            :id_content="335"
            :hidden="!show2"
            title-class="contentHeading"
            sub-title-class="contentSubTitle"
            text-class="contentText"
        />
      </v-col>
      <v-col
          :v-if="show3 || isAuth"
          cols="12" lg="6" md="6" sm="11" offset-lg="1" offset-md="1" offset-sm="0" style="margin-top: 24px"
          class="partnership-right-column">
        <content-text
            :sub-title="$t('message.partnershipSubHead4')"
            :content="'<ul><li><p>'+$t('message.partnershipText15')+'</p></li>' +
             '<li><p>' + $t('message.partnershipText16')+'</p></li>' +
             '<li><p>' + $t('message.partnershipText17')+'</p></li>' +
             '<li><p>' + $t('message.partnershipText18')+'</p></li></ul> ' +
             '<p>'+ $t('message.partnershipText19') + gorHref +
             $t('message.partnershipText20') + mailHref +
             $t('message.partnershipText21') + phoneHref + '</p>'"
            :id_title="336"
            :id_sub-title="337"
            :id_content="338"
            :hidden="!show3"
            title-class="contentHeading"
            sub-title-class="contentSubTitle partnershipSubTitle"
            text-class="contentText contentTextSuppliers contentAnticorruptio"
        />
      </v-col>
    </v-row>
    <v-row class="mb-8 mt-8 mx-auto" style="height: 60px">
      <div class="partnership-blue-line"/>
    </v-row>
    <v-row class="partnership">
      <v-col cols="12" lg="5" md="5" sm="11" class="partnership__content">
        <content-text
            v-if="show4 || isAuth"
            class="partnership__left-border"
            :sub-title="$t('message.partnershipSubHead4')"
            :content="'<ul><li><p>'+$t('message.partnershipText15')+'</p></li>' +
             '<li><p>' + $t('message.partnershipText16')+'</p></li>' +
             '<li><p>' + $t('message.partnershipText17')+'</p></li>' +
             '<li><p>' + $t('message.partnershipText18')+'</p></li></ul> ' +
             '<p>'+ $t('message.partnershipText19') + gorHref +
             $t('message.partnershipText20') + mailHref +
             $t('message.partnershipText21') + phoneHref + '</p>'"
            :id_title="391"
            :id_sub-title="392"
            :id_content="393"
            :hidden="!show4"
            title-class="contentHeading"
            sub-title-class="contentSubTitle partnershipSubTitle"
            text-class="contentText contentTextSuppliers contentAnticorruptio"
        />
        <content-text
            v-if="show5 || isAuth"
            class="partnership__left-border"
            :sub-title="$t('message.partnershipSubHead4')"
            :content="'<ul><li><p>'+$t('message.partnershipText15')+'</p></li>' +
             '<li><p>' + $t('message.partnershipText16')+'</p></li>' +
             '<li><p>' + $t('message.partnershipText17')+'</p></li>' +
             '<li><p>' + $t('message.partnershipText18')+'</p></li></ul> ' +
             '<p>'+ $t('message.partnershipText19') + gorHref +
             $t('message.partnershipText20') + mailHref +
             $t('message.partnershipText21') + phoneHref + '</p>'"
            :id_title="404"
            :id_sub-title="405"
            :id_content="406"
            :hidden="!show5"
            title-class="contentHeading"
            sub-title-class="contentSubTitle partnershipSubTitle"
            text-class="contentText contentTextSuppliers contentAnticorruptio"
        />
      </v-col>
      <v-col
          cols="12" lg="6" md="6" sm="11" offset-lg="1" offset-md="1" offset-sm="0"
          class="partnership__content partnership-right-column">
        <content-text
            v-if="show6 || isAuth"
            class="partnership__text-with-background"
            :sub-title="$t('message.partnershipSubHead4')"
            :content="'<ul><li><p>'+$t('message.partnershipText15')+'</p></li>' +
             '<li><p>' + $t('message.partnershipText16')+'</p></li>' +
             '<li><p>' + $t('message.partnershipText17')+'</p></li>' +
             '<li><p>' + $t('message.partnershipText18')+'</p></li></ul> ' +
             '<p>'+ $t('message.partnershipText19') + gorHref +
             $t('message.partnershipText20') + mailHref +
             $t('message.partnershipText22') + phoneHref + '</p>'"
            :id_title="258"
            :id_sub-title="259"
            :id_content="260"
            :hidden="!show6"
            title-class="contentHeading"
            sub-title-class="contentSubTitle partnershipSubTitle"
            text-class="contentText contentTextSuppliers contentAnticorruptio"
        />
        <content-image
            class="partnership__text-with-background__image"
            :img-src="$t('message.partnershipSchemeSRC')"
            :is_link="true"
            :id_img-src="261"
            img-class="partnershipImg"
        />
      </v-col>
    </v-row>
    <v-row class="mb-8 mt-8 mx-auto" style="height: 60px">
      <div class="partnership-blue-line"/>
    </v-row>
  </v-container>
</template>
<script>
// [
//     258, 259, 260, 261, 262, 263, 264, 265,
//     330, 331, 332, 333, 334, 335, 336, 337,
//     338, 391, 392, 393, 404, 405, 406, 407, 408
// ]

import '../assets/sass/app.scss'
import '../plugins/i18n.js'
import PartnershipSubmenu from '../components/ui/PartnershipSubmenu.vue'
import ContentText from '../components/ui/ContentText'
import ContentNumeric from '../components/ui/ContentNumeric'
import AboutCompanySubmenu from '../components/ui/AboutCompanySubmenu'
import OfferGoodsForm from '../components/ui/OfferGoodsForm'
import ReportForm from '../components/ui/ReportForm'
import TextHref from "@/components/ui/TextHref.vue";
import {mdiChevronRight} from '@mdi/js'

export default {
  components: {PartnershipSubmenu, ContentText, ContentNumeric, AboutCompanySubmenu, OfferGoodsForm, ReportForm},
  data() {
    return {
      gorHref: '<a href="https://городскаяаптека.рф" target="_blank" class="colloredLink">городскаяаптека.рф</a>',
      span1: '<span class="contentNote">* </span>',
      span2: '<span class="contentNote">*' + this.$t("message.partnershipText13") + ' </span>',
      mailHref: '<a href="mailto:farminn@farminn.ru" target="_blank" class="colloredLink"> farminn@farminn.ru </a>',
      phoneHref: '<a class="colloredLink" href="tel:' + this.$t("message.contactPhoneNum") + '">' + this.$t("message.contactPhoneNum") + '</a>',
      svgAllNewsBtnPath: mdiChevronRight,
      toggle_exclusive: 1,
      imagesIds: [12000, 12004, 12008, 12012, 12016, 12020],
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      show6: false,
      showObject: {
        12000: false,
        12004: false,
        12008: false,
        12012: false,
        12016: false,
        12020: false,
      }
    }
  },
  created() {
    let IdList1 = [[330, 331, 332]]
    this.$store.dispatch('contentChanges/CHECK_HIDDEN_CONTENT_LIST', {'id_list': IdList1})
        .then(() => {
          let hiddenContent = this.$store.getters['contentChanges/hidden_content']
          this.show1 = !hiddenContent[0]
        })

    let IdList2 = [[333, 334, 335]]
    this.$store.dispatch('contentChanges/CHECK_HIDDEN_CONTENT_LIST', {'id_list': IdList2})
        .then(() => {
          let hiddenContent = this.$store.getters['contentChanges/hidden_content']
          this.show2 = !hiddenContent[0]
        })

    let IdList3 = [[336, 337, 338]]
    this.$store.dispatch('contentChanges/CHECK_HIDDEN_CONTENT_LIST', {'id_list': IdList3})
        .then(() => {
          let hiddenContent = this.$store.getters['contentChanges/hidden_content']
          this.show3 = !hiddenContent[0]
        })

    let IdList4 = [[391, 392, 393]]
    this.$store.dispatch('contentChanges/CHECK_HIDDEN_CONTENT_LIST', {'id_list': IdList4})
        .then(() => {
          let hiddenContent = this.$store.getters['contentChanges/hidden_content']
          this.show4 = !hiddenContent[0]
        })

    let IdList5 = [[404, 405, 406]]
    this.$store.dispatch('contentChanges/CHECK_HIDDEN_CONTENT_LIST', {'id_list': IdList5})
        .then(() => {
          let hiddenContent = this.$store.getters['contentChanges/hidden_content']
          this.show5 = !hiddenContent[0]
        })

    let IdList6 = [[258, 259, 260]]
    this.$store.dispatch('contentChanges/CHECK_HIDDEN_CONTENT_LIST', {'id_list': IdList6})
        .then(() => {
          let hiddenContent = this.$store.getters['contentChanges/hidden_content']
          this.show6 = !hiddenContent[0]
        })

    // Теперь this.imagesIds существует, и цикл отработает без проблем
    this.imagesIds.forEach(id => {
      let idList = [[id + 1, id + 2, id + 3]]
      this.$store.dispatch('contentChanges/CHECK_HIDDEN_CONTENT_LIST', {'id_list': idList})
          .then(() => {
            let hiddenContent = this.$store.getters['contentChanges/hidden_content']
            this.showObject[id] = !hiddenContent[0]
          })
    })
  },
  metaInfo: {
    meta: [
      {
        name: 'description',
        content: 'Информация для поставщиков о компании Фарм-Инновации, формы предложения товара, запрос на получение информации по продажам'
      },
      {
        name: 'title',
        content: 'Поставщикам'
      }
    ]
  },
  computed: {
    isAuth() {
      return this.$store.getters['adminAuth/checkAuth']
    }
  }
}
</script>
